import React from 'react';
import videoPlayer from '../assets/video-player.png';
import { Link } from 'react-router-dom';

const HomeContact = (props) => {
  return (
    <div>
      <div className="py-5 text-start" style={{ backgroundColor: '#00b8f1' }}>
        <div className="container-lg">
          <div className="row align-items-center">
            <div className="col-md-6 text-white mb-4 mb-md-0">
              <p className="text-uppercase fw-semibold">
                {props.smallHeading}
              </p>
              <h2 className="fw-bold mb-3">
                {props.largeHeading}
              </h2>
              <p className="fw-light">
                {props.lightHeading}
              </p>

              {/* ✅ Clean white "Contact Us" button */}
              <Link
                to="/contact-us"
                className="btn btn-light d-inline-flex align-items-center gap-2 px-4 py-2 fw-semibold rounded-pill mt-4 shadow-sm"
                style={{ fontSize: '1.1rem', color: '#00b8f1' }}
              >
                Contact Us
              </Link>
            </div>

            <div className="col-md-6 text-center">
              <img
                src={videoPlayer}
                alt="Video Player"
                className="img-fluid"
                style={{ maxHeight: '350px' }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeContact;
